<div class="affected-service-item">
  @if (hasDetailPage()) {
    <a class="no-style-link affected-service-item__icon-link" [routerLink]="routerLink()">
      <service-icon size="m" [type]="iconType()" />
    </a>
  } @else {
    <service-icon size="m" [type]="iconType()" />
  }

  <div class="affected-service-item__caption">
    <div class="affected-service-item__title">
      <div>
        @if (hasDetailPage()) {
          <a class="no-style-link" [routerLink]="routerLink()">{{ description() }}</a>
        } @else {
          {{ description() }}
        }
      </div>
    </div>
    <div id="service-id-container"><service-id [subscriptionId]="subscriptionId()" /></div>
    <div class="affected-service-item__subtitle">{{ impact() | cim_impact_type }}</div>
  </div>
  @if (hasDetailPage()) {
    <a class="no-style-link" [routerLink]="routerLink()">
      <svg-icon class="affected-service-item__arrow" src="assets/images/icons/arrow-small-right.svg"></svg-icon>
    </a>
  }
</div>
